import MembershipProfile from '@components/membership/membership-profile/MembershipProfile'
import MembershipSubscription from '@components/membership/subscription/MembershipSubscription'
import { useMembershipProfileContext } from '@contexts/membership/MembershipProfileContext'
import { useAppSelector } from '@store/hooks'
import { selectMembershipProfileById } from '@store/membership/MembershipProfileReducer'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Card, Flex } from 'antd'

const FormAnswersSection = () => {
  const { id } = useMembershipProfileContext()
  const membershipProfile = useAppSelector(selectMembershipProfileById(id))

  if (!membershipProfile) return null

  return (
    <Flex vertical gap={8}>
      <PageTitle level={5} title="Form Answers" style={{ margin: 0 }} />
      <Flex vertical gap={10}>
        <Card styles={{ body: { padding: 16 } }}>
          <MembershipProfile.Description hideAvatar model={membershipProfile} />
        </Card>
        <Card styles={{ body: { padding: 16 } }}>
          <MembershipSubscription.FormAnswers
            id={membershipProfile.subscription}
          />
        </Card>
      </Flex>
    </Flex>
  )
}

export default FormAnswersSection
